import Api from "@/api/base";
import Vue from "vue";
import ElementsTreeNode from "@/modules/cascading/components/ElementsTree/ElementsTreeNodeClass";

function findNodesById(state, nodes, targetId) {
  const result = [];

  function search(currentNodes) {
    for (const node of currentNodes) {
      if (node.id === targetId) {
        result.push(node);
      }
      if (node.childrenNodes && node.childrenNodes.length) {
        search(node.childrenNodes);
      }
    }
  }

  search(nodes);
  return result;
}


export default {
  namespaced: true,

  state: {
    loading: false,
    nodes: []
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    nodes(state) {
      return state.nodes;
    }

  },
  actions: {
    loadElements(ctx, payload) {
      ctx.commit("setLoading", true);
      return Api.cascading.elementsGetByCardId(payload)
        .then((data) => {
          ctx.commit("updateElementsToNodes", {
            elements: data.elements
          });
        })
        .finally(() => {
          ctx.commit("setLoading", false);
        });
    },

    elementNewDataReceived(ctx, payload) {
      ctx.commit("updateElementData", payload.elementData);
    },


  },

  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },

    updateElementsToNodes(state, { elements }) {
      const nodesToSet = [];
      elements.forEach(element => {
        nodesToSet.push(new ElementsTreeNode(element));
      });
      state.nodes = nodesToSet;
    },

    updateElementData(state, elementData){
      findNodesById(state, state.nodes, elementData.id).forEach(node => {
        node.model = elementData;
      });
    }

  }
};